import React, { ReactNode, RefObject, useRef, useState } from 'react';
import {
  globalLayoutContext,
  GlobalLayoutContext,
} from './useGlobalLayoutContext';
import { useContainerBreakpoint } from '@im/ui-lib/zenith/responsive';
import { useElementDimensions } from '@im/ui-lib/zenith/utils';

type GlobalLayoutProviderProps = {
  children: ReactNode;
};

export function GlobalLayoutProvider({
  children,
}: Readonly<GlobalLayoutProviderProps>) {
  const emptyRef = useRef<HTMLDivElement>(null);

  const [viewContainer, setViewContainer] = useState<
    RefObject<HTMLDivElement> | undefined
  >();

  const initViewContainer: GlobalLayoutContext['initViewContainer'] = (ref) => {
    if (viewContainer === undefined) {
      setViewContainer(ref);
    }
  };

  const { width: viewWidth } = useElementDimensions(viewContainer);

  const { getBreakpoint, isContainerDown, isContainerUp, isMobile } =
    useContainerBreakpoint(viewContainer ?? emptyRef);

  const { Provider } = globalLayoutContext;
  return (
    <Provider
      value={{
        getViewBreakpoint: getBreakpoint,
        initViewContainer,
        isViewDown: isContainerDown,
        isViewUp: isContainerUp,
        view: {
          breakpoint: getBreakpoint(),
          isMobile,
          width: viewWidth,
        },
      }}
    >
      {children}
    </Provider>
  );
}
